import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { renderToString } from 'react-dom/server'
import api from '../services/api_adiantamento';
import './index.css';

import { FaRecycle, FaArrowAltCircleLeft } from "react-icons/fa";
import { BsFillBellFill, BsFolderX, BsChevronDoubleLeft, BsChevronDoubleRight } from "react-icons/bs";
import { TiTick } from 'react-icons/ti';
import * as icons from "react-icons/all";

import styles from "./styles.module.css";
import stylesnotif from "./notif-styles.module.css";
import 'moment/locale/pt-br';
import moment from 'moment';


export default function Homepage() {
    const [usuario, setUsuario] = useState({ modulos: [] });
    const [carregando, setCarregando] = useState(true);
    const [loadingNotificacoes, setLoadingNotificacoes] = useState(true);
    // Notificações Automáticas
    const [saveStopNotificacoesAutomaticas, setSaveStopNotificacoesAutomaticas] = useState(false);
    const [inputStopNotificacoesAutomaticas, setInputStopNotificacoesAutomaticas] = useState(false);
    const [notificacoesAutomaticas, setNotificacoesAutomaticas] = useState([]);
    // Notificações
    const [modalNotificacoesUsuario, setModalNotificacoesUsuario] = useState(false);
    const [notificacoesUsuario, setNotificacoesUsuario] = useState([]);
    const [selectedNotificacoesUsuario, setSelectedNotificacoesUsuario] = useState(null);
    // Novidades
    const [modalNovidadesModulos, setModalNovidadesModulos] = useState(false);
    const [loadingNovidadesModulos, setLoadingNovidadesModulos] = useState(false);
    const [novidadesModulos, setNovidadesModulos] = useState([]);
    const [selectedNovidadesModulos, setSelectedNovidadesModulos] = useState(0);

    const calendarFormat = {
        lastDay : '[Ontem], D [de] MMMM',
        sameDay : '[Hoje], D [de] MMMM',
        nextDay : 'dddd, D [de] MMMM',
        lastWeek : 'dddd, D [de] MMMM',
        nextWeek : 'dddd, D [de] MMMM',
        sameElse : 'LL'
    }
    const calendarFormatMin = {
        lastDay : '[Ontem]',
        sameDay : '[Hoje]',
        nextDay : 'D [de] MMM',
        lastWeek : 'D [de] MMM',
        nextWeek : 'D [de] MMM',
        sameElse : 'L'
    }

    let history = useHistory();

    useEffect(() => {
        if(carregando) {
            api.get(`/usuarios/getbytoken`).then(function (response) {
                if (response.data) {
                    setUsuario(response.data);
                }
            }).catch(function (error) {
                console.log(error);
            }).finally(function () {
                setCarregando(false);
            });
        }
    }, [carregando]);

    useEffect(() => {
        if(loadingNotificacoes) {
            api.get(`/notificacoes/getnotifications`).then(function (response) {
                if (response.data.notificacoes_automaticas) {
                    setNotificacoesAutomaticas(response.data.notificacoes_automaticas);
                }
                if (response.data.novidades_modulos) {
                    setNovidadesModulos(response.data.novidades_modulos);
                }
                if (response.data.notificacoes_usuario) {
                    setNotificacoesUsuario(response.data.notificacoes_usuario);
                }
            }).catch(function (error) {
                console.log(error);
            }).finally(function () {
                setLoadingNotificacoes(false);
            });
        }
    }, [loadingNotificacoes]);

    useEffect(() => {
        if(carregando || loadingNotificacoes || modalNotificacoesUsuario || modalNovidadesModulos || (notificacoesAutomaticas && notificacoesAutomaticas.length)) {
            document.body.classList.add(styles.blockbody);
        }
        else {
            document.body.classList.remove(styles.blockbody);
        }
    }, [carregando, loadingNotificacoes, modalNotificacoesUsuario, modalNovidadesModulos, notificacoesAutomaticas]);

    function handleSwapNovidadesModulos(newSelected) {
        setLoadingNovidadesModulos(true);
        setSelectedNovidadesModulos(newSelected);

        setTimeout(() => {
            setLoadingNovidadesModulos(false);
        }, 300);
    }

    function translateTagIcons(text) {
        const tagIcons = text.match(/:{#\w+}:/g);

        if(tagIcons) {
            const arrayText = text.replaceAll(/:{#\w+}:/g, '||$&||').split('||');

            tagIcons.forEach(tagIcon => {
                let findedIndex = arrayText.findIndex(position => position === tagIcon);

                if(findedIndex !== -1) {
                    arrayText[findedIndex] = renderToString(icons[tagIcon.replace(/(^:{#|}:$)/g, '')]({size: 18, color: '#487db9'}));
                }
            });

            return arrayText.join('');
        }

        return text;
    }

    function translateWithoutTagIcons(text) {
        return text.replaceAll(/:{#\w+}:/g, '');
    }

    function handleClick(id) {
        history.push(usuario.modulos.find(modulo => modulo.id === parseInt(id)).rota);
    }

    function renderModulos() {
        if (!carregando) {
            return (
                usuario.modulos.map((modulo, index) => {
                    return (
                        <button className="btn btn-primary" id={modulo.id} type="submit" key={index} onClick={() => handleClick(modulo.id)}>
                            {icons[modulo.icon]({className: 'icon'})}
                            {modulo.descricao}
                        </button>
                    )
                })
            )
        }
    }

    function loading() {
        if(carregando || loadingNotificacoes || saveStopNotificacoesAutomaticas) {
            return (
                <div className={styles.conteinerloading}>
                    <div className={styles.divloading}>
                        <div className={styles.loading}></div>
                    </div>
                </div>
            )
        }
    }

    // NOTIFICAÇÕES

    function stopNotification(objNotificacao, index, stop) {
        setSaveStopNotificacoesAutomaticas(true);

        if(stop) {
            setInputStopNotificacoesAutomaticas(false);
            api.post(`/notificacoes/stopnotification`, {notificacoes: [{id: objNotificacao[index].id}]}).catch(error => {
                console.log(error);
            });
        }

        let newObj = Object.assign([], objNotificacao);
        newObj.splice(index, 1);

        setTimeout(() => {
            setSaveStopNotificacoesAutomaticas(false);
        }, 300);

        return newObj;
    }

    function renderButtonRedirecionarNotificacao(redirecionar, texto, url, id_notificacao, stop) {
        if(redirecionar) {
            return (
                <div className={stylesnotif.conteinerbuttonredirect}>
                    <input type='button' className={[stylesnotif.buttons, stylesnotif.redirectbutton].join(' ')}
                        value={texto} onClick={() => {
                            if(stop) {
                                api.post(`/notificacoes/stopnotification`, {notificacoes: [{id: id_notificacao}]}).catch(error => {
                                    console.log(error);
                                });
                            }

                            if((/^http:\/\/|^https:\/\//g).test(url)) {
                                window.open(url, '_blank');
                            } else {
                                history.push(url, {id_notificacao: id_notificacao});
                            }
                        }}
                    />
                </div>
            )
        }
    }

    function renderStopNotificacoesAutomaticas(parar_notificacao) {
        if(parar_notificacao) {
            return (
                <div className={stylesnotif.conteinerfooternotificacao}>
                    <div className={stylesnotif.conteinerstopnotification} onClick={() => setInputStopNotificacoesAutomaticas(!inputStopNotificacoesAutomaticas)}>
                        <div className={stylesnotif.checkconteiner}>
                            <TiTick className={inputStopNotificacoesAutomaticas ? stylesnotif.checkicon : stylesnotif.checkiconnone} />
                        </div>
                        Marcar como Lido
                    </div>
                </div>
            )
        }
    }

    function renderModalNotificacoesAutomaticas() {
        if(notificacoesAutomaticas && notificacoesAutomaticas.length && !saveStopNotificacoesAutomaticas) {
            return (
                <div className={stylesnotif.conteiner}>
                    <div className={[stylesnotif.modal, stylesnotif.modalmaxheight3rows].join(' ')}>
                        <div>
                            <div className={stylesnotif.titlenotificacao}>
                                <div dangerouslySetInnerHTML={{__html: translateTagIcons(notificacoesAutomaticas[0].titulo)}} />
                            </div>
                            <div className={stylesnotif.datanotificacao}>
                                {moment(notificacoesAutomaticas[0].data_notificacao, 'DD MM YYYY').calendar(calendarFormat)}
                            </div>
                        </div>
                        <div className={[stylesnotif.conteinerbody, stylesnotif.conteinerbodymaxheight].join(' ')}>
                            <div className={stylesnotif.textonotificacao}>
                                <div dangerouslySetInnerHTML={{__html: translateTagIcons(notificacoesAutomaticas[0].texto)}} />
                                <div>
                                    {renderButtonRedirecionarNotificacao(notificacoesAutomaticas[0].redirecionar, notificacoesAutomaticas[0].texto_redirecionamento, notificacoesAutomaticas[0].url_redirecionamento, notificacoesAutomaticas[0].id, inputStopNotificacoesAutomaticas)}
                                    {renderStopNotificacoesAutomaticas(notificacoesAutomaticas[0].parar_notificacao)}
                                </div>
                            </div>
                        </div>
                        <div className={stylesnotif.conteinerbuttons}>
                            <input type='button' className={[stylesnotif.buttons, stylesnotif.cancelbutton].join(' ')}
                                value='Fechar' onClick={() => setNotificacoesAutomaticas(stopNotification(notificacoesAutomaticas, 0, inputStopNotificacoesAutomaticas))}
                            />
                        </div>
                    </div>
                </div>
            )
        }
    }

    function closeNotificacoesUsuario() {
        let newObj = [];
        var notificacoesToConfim = [];

        notificacoesUsuario.forEach(notificacao => {
            if(notificacao.stop_notification) {
                notificacoesToConfim.push({id: notificacao.id});
            } else {
                newObj.push(notificacao);
            }
        });

        if(notificacoesToConfim.length) {
            api.post(`/notificacoes/stopnotification`, {notificacoes: notificacoesToConfim}).catch(error => {
                console.log(error);
            });
        }

        setSelectedNotificacoesUsuario(null);
        setNotificacoesUsuario(newObj);
        setModalNotificacoesUsuario(false);
    }

    function handleStopNotificacoesUsuario(objNotificacao, index) {
        let newObj = Object.assign([], objNotificacao);
        newObj[index].stop_notification = !newObj[index].stop_notification;

        setNotificacoesUsuario(newObj);
    }

    function renderStopNotificacoesUsuario(parar_notificacao) {
        if(parar_notificacao) {
            return (
                <div className={stylesnotif.conteinerfooternotificacao}>
                    <div className={stylesnotif.conteinerstopnotification} onClick={() => handleStopNotificacoesUsuario(notificacoesUsuario, selectedNotificacoesUsuario)}>
                        <div className={stylesnotif.checkconteiner}>
                            <TiTick className={notificacoesUsuario[selectedNotificacoesUsuario].stop_notification ? stylesnotif.checkicon : stylesnotif.checkiconnone} />
                        </div>
                        Marcar como Lido
                    </div>
                </div>
            )
        }
    }

    function renderListNotificacoesUsuario() {
        if(notificacoesUsuario.length) {
            return (
                <div className={[stylesnotif.conteinerlistnotificacao, (selectedNotificacoesUsuario != null ? stylesnotif.conteinerlistnotificacaonone : '')].join(' ')}>
                    {notificacoesUsuario.map((notificacao, index) => {
                        return (
                            <div className={stylesnotif.listnotificacao} key={index} onClick={() => setSelectedNotificacoesUsuario(index)}>
                                {renderNaoLido(!notificacao.stop_notification)}
                                <div className={[stylesnotif.titlenotificacao, stylesnotif.titlenotificacaounicline].join(' ')}>
                                    <div dangerouslySetInnerHTML={{__html: translateWithoutTagIcons(notificacao.titulo)}} />
                                </div>
                                <div className={stylesnotif.datanotificacao}>
                                    {moment(notificacao.data_notificacao, 'DD MM YYYY').calendar(calendarFormatMin)}
                                </div>
                            </div>
                        )
                    })}
                </div>
            )
        } else {
            return (
                <div className={[stylesnotif.conteinerlistnotificacao, stylesnotif.conteinerlistnotificacaonone].join(' ')}>
                    <div className={stylesnotif.listnotificacaoempty}>
                        <BsFolderX className={stylesnotif.iconnotificacaoempty} />
                    </div>
                </div>
            )
        }
    }

    function renderBodyNotificacoesUsuario() {
        if(!notificacoesUsuario.length) {
            return (
                <div className={stylesnotif.conteinerbodynotificacao}>
                    <div></div>
                    <div className={stylesnotif.bodynotificacaonotselected}>Nenhuma notificação pendente.</div>
                </div>
            )
        } else if(selectedNotificacoesUsuario != null) {
            return (
                <div className={stylesnotif.conteinerbodynotificacao}>
                    <div className={stylesnotif.bodytitlenotificacao}>
                        <div className={stylesnotif.bodynotificacaoback}>
                            <div className={stylesnotif.conteinerbodyiconnotificacaoback} onClick={() => setSelectedNotificacoesUsuario(null)}>
                                <FaArrowAltCircleLeft className={stylesnotif.bodyiconnotificacaoback}/>
                                VOLTAR
                            </div>
                        </div>
                        <div className={stylesnotif.titlenotificacao}>
                            <div dangerouslySetInnerHTML={{__html: translateTagIcons(notificacoesUsuario[selectedNotificacoesUsuario].titulo)}} />
                        </div>
                        <div className={stylesnotif.datanotificacao}>
                            {moment(notificacoesUsuario[selectedNotificacoesUsuario].data_notificacao, 'DD MM YYYY').calendar(calendarFormat)}
                        </div>
                    </div>
                    <div className={stylesnotif.textonotificacao}>
                        <div dangerouslySetInnerHTML={{__html: translateTagIcons(notificacoesUsuario[selectedNotificacoesUsuario].texto)}} />
                        <div>
                            {renderButtonRedirecionarNotificacao(notificacoesUsuario[selectedNotificacoesUsuario].redirecionar, notificacoesUsuario[selectedNotificacoesUsuario].texto_redirecionamento, notificacoesUsuario[selectedNotificacoesUsuario].url_redirecionamento, notificacoesUsuario[selectedNotificacoesUsuario].id, notificacoesUsuario[selectedNotificacoesUsuario].stop_notification)}
                            {renderStopNotificacoesUsuario(notificacoesUsuario[selectedNotificacoesUsuario].parar_notificacao)}
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className={[stylesnotif.conteinerbodynotificacao, stylesnotif.conteinerbodynotificacaonone].join(' ')}>
                    <div></div>
                    <div className={stylesnotif.bodynotificacaonotselected}>Nenhuma notificação selecionada.</div>
                </div>
            )
        }
    }

    function renderBodyModalNotificacoesUsuario() {
        return (
            <div className={[stylesnotif.conteinerbody, stylesnotif.conteinerbodymaxheight, stylesnotif.conteinerbodycolumns].join(' ')}>
                {renderListNotificacoesUsuario()}
                {renderBodyNotificacoesUsuario()}
            </div>
        )
    }

    function renderModalNotificacoesUsuario() {
        if(modalNotificacoesUsuario) {
            return (
                <div className={stylesnotif.conteiner}>
                    <div className={[stylesnotif.modal, stylesnotif.modallargerwidth, stylesnotif.modalmaxheight3rows].join(' ')}>
                        <div className={stylesnotif.modaltitlenotificacao}>NOTIFICAÇÕES</div>
                        {renderBodyModalNotificacoesUsuario()}
                        <div className={stylesnotif.conteinerbuttons}>
                            <input type='button' className={[stylesnotif.buttons, stylesnotif.cancelbutton].join(' ')}
                                value='Fechar' onClick={() => closeNotificacoesUsuario()}
                            />
                        </div>
                    </div>
                </div>
            )
        }
    }

    function closeNovidades() {
        let newObj = [];
        var novidadesToConfim = [];

        novidadesModulos.forEach(novidade => {
            if(novidade.stop_notification) {
                novidadesToConfim.push({id: novidade.id});
            } else {
                newObj.push(novidade);
            }
        });

        if(novidadesToConfim.length) {
            api.post(`/notificacoes/stopnotification`, {notificacoes: novidadesToConfim}).catch(error => {
                console.log(error);
            });
        }

        setSelectedNovidadesModulos(0);
        setNovidadesModulos(newObj);
        setModalNovidadesModulos(false);
    }

    function handleStopNovidades(objNotificacao, index) {
        let newObj = Object.assign([], objNotificacao);
        newObj[index].stop_notification = !newObj[index].stop_notification;

        setNovidadesModulos(newObj);
    }

    function renderStopNovidades(parar_notificacao) {
        if(parar_notificacao) {
            return (
                <div className={stylesnotif.conteinerfooternotificacao}>
                    <div className={stylesnotif.conteinerstopnotification} onClick={() => handleStopNovidades(novidadesModulos, selectedNovidadesModulos)}>
                        <div className={stylesnotif.checkconteiner}>
                            <TiTick className={novidadesModulos[selectedNovidadesModulos].stop_notification ? stylesnotif.checkicon : stylesnotif.checkiconnone} />
                        </div>
                        Marcar como Lido
                    </div>
                </div>
            )
        }
    }

    function renderSwapLeft() {
        if(selectedNovidadesModulos > 0) {
            return (
                <div className={stylesnotif.conteinerbodynotificacaoswapicon} onClick={() => handleSwapNovidadesModulos(selectedNovidadesModulos - 1)}>
                    <BsChevronDoubleLeft className={stylesnotif.bodynotificacaoswapicon} />
                </div>
            )
        } else {
            return (
                <div />
            )
        }
    }

    function renderSwapRigth() {
        if(selectedNovidadesModulos < (novidadesModulos.length - 1)) {
            return (
                <div className={stylesnotif.conteinerbodynotificacaoswapicon} onClick={() => handleSwapNovidadesModulos(selectedNovidadesModulos + 1)}>
                    <BsChevronDoubleRight className={stylesnotif.bodynotificacaoswapicon} />
                </div>
            )
        } else {
            return (
                <div />
            )
        }
    }

    function renderBodyModalNovidadesNovidade() {
        if(loadingNovidadesModulos) {
            return (
                <div className={stylesnotif.conteinerbodynotificacao}>
                    <div className={stylesnotif.bodytitlenotificacao}>
                        <br /><br />
                    </div>
                    <div className={stylesnotif.conteinerbodynotificacaoloading}>
                        <div className={styles.divloading}>
                            <div className={styles.loading}></div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className={stylesnotif.conteinerbodynotificacao}>
                    <div className={stylesnotif.bodytitlenotificacao}>
                        <div className={stylesnotif.titlenotificacao}>
                            <div dangerouslySetInnerHTML={{__html: translateTagIcons(novidadesModulos[selectedNovidadesModulos].titulo)}} />
                        </div>
                        <div className={stylesnotif.datanotificacao}>
                            {moment(novidadesModulos[selectedNovidadesModulos].data_notificacao, 'DD MM YYYY').calendar(calendarFormat)}
                        </div>
                    </div>
                    <div className={stylesnotif.textonotificacao}>
                        <div dangerouslySetInnerHTML={{__html: translateTagIcons(novidadesModulos[selectedNovidadesModulos].texto)}} />
                        <div>
                            {renderButtonRedirecionarNotificacao(novidadesModulos[selectedNovidadesModulos].redirecionar, novidadesModulos[selectedNovidadesModulos].texto_redirecionamento, novidadesModulos[selectedNovidadesModulos].url_redirecionamento, novidadesModulos[selectedNovidadesModulos].id, novidadesModulos[selectedNovidadesModulos].stop_notification)}
                            {renderStopNovidades(novidadesModulos[selectedNovidadesModulos].parar_notificacao)}
                        </div>
                    </div>
                </div>
            )
        }
    }

    function renderBodyModalNovidades() {
        if(!novidadesModulos.length) {
            return (
                <div className={stylesnotif.conteinerbodynotificacao}>
                    <div></div>
                    <div className={stylesnotif.bodynotificacaonotselected}>Nenhuma notificação pendente.</div>
                </div>
            )
        } else {
            return (
                <div className={[stylesnotif.conteinerbody, stylesnotif.conteinerbodymaxheight, stylesnotif.conteinerbodynoticias].join(' ')}>
                    {renderBodyModalNovidadesNovidade()}
                    <div className={stylesnotif.conteinerbodynotificacaoswap}>
                        {renderSwapLeft()}
                        {renderSwapRigth()}
                    </div>
                </div>
            )
        }
    }

    function renderModalNovidades() {
        if(modalNovidadesModulos) {
            return (
                <div className={stylesnotif.conteiner}>
                    <div className={[stylesnotif.modal, stylesnotif.modallargerwidth, stylesnotif.modalmaxheight3rows].join(' ')}>
                        <div className={stylesnotif.modaltitlenotificacao}>NOVIDADES</div>
                        {renderBodyModalNovidades()}
                        <div className={stylesnotif.conteinerbuttons}>
                            <input type='button' className={[stylesnotif.buttons, stylesnotif.cancelbutton].join(' ')}
                                value='Fechar' onClick={() => closeNovidades()}
                            />
                        </div>
                    </div>
                </div>
            )
        }
    }

    function renderNaoLido(notificacoes) {
        return (
            <span className={[stylesnotif.conteinernaolidos, notificacoes ? '' : stylesnotif.conteinernaolidoshide].join(' ')}>
            </span>
        )
    }

    function renderNoticias() {
        return (
            <div className={stylesnotif.conteinericonnotifications} onClick={() => { if(!loadingNotificacoes) { setModalNovidadesModulos(true) } }}>
                {renderNaoLido(novidadesModulos.length)}
                <FaRecycle className={stylesnotif.iconnotifications} />
            </div>
        )
    }

    function renderNotificacoes() {
        return (
            <div className={stylesnotif.conteinericonnotifications} onClick={() => { if(!loadingNotificacoes) { setModalNotificacoesUsuario(true) } }}>
                {renderNaoLido(notificacoesUsuario.length)}
                <BsFillBellFill className={stylesnotif.iconnotifications} />
            </div>
        )
    }

    return (
        <>
            {loading()}
            {renderModalNotificacoesAutomaticas()}
            {renderModalNotificacoesUsuario()}
            {renderModalNovidades()}
            <div className="container-lg">
                <div className="mb-2">
                    <div className={stylesnotif.conteinernotifications}>
                        {renderNoticias()}
                        {renderNotificacoes()}
                    </div>
                    <div className={styles.modulos}>
                        {renderModulos()}
                    </div>
                </div>
            </div>
        </>
    )
}